import {RegistrationApiGet} from "./reg_api";
import * as yup from "yup";

export type FinishProps = {
    onCancel: () => void
    reg: RegistrationApiGet
}


export const RegEditSchema = yup.object().shape({
    workOrder: yup.object().nullable(),
    worker: yup.object().required(),
    machine: yup.object().nullable(),
    workTask: yup.object().required(),
    product: yup.object().nullable(),
    StartTime: yup.date().required(),
    EndTime: yup.date().nullable(),
    Quantity: yup.number().required().min(0),
    ScrapQuantity: yup.number().required().min(0),

})


export const RegFinishSchema = yup.object().shape({
    EndTime: yup.date().nullable(),
    Quantity: yup.number().required().min(0),
    ScrapQuantity: yup.number().required().min(0),

})